import { render, staticRenderFns } from "./UserAggrement.vue?vue&type=template&id=ff369b6c&"
import script from "./UserAggrement.vue?vue&type=script&lang=js&"
export * from "./UserAggrement.vue?vue&type=script&lang=js&"
import style0 from "./UserAggrement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports